import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Select, Input, DatePicker, InputNumber, Form, Button, message, Cascader, Popover, Spin } from 'antd';
import moment from 'moment';//日期格式化导包
import { CloseCircleOutlined, QuestionCircleOutlined, EyeOutlined } from '@ant-design/icons';
import NewMessage from '../../component/newMessage/newMessage';
import SelectStudenModal from './selectStudenModal';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';

import './partnerCreateJobPosting.css';

import saveImg from '../../public/img/newMain/Save.png';
import submitImg from '../../public/img/newMain/Submit.png';
import CompanyLogo from '../../public/img/company/companyLogo.png';
import studentDefaultPictureImg from '../../public/img/newMain/studentDefaultPicture.png'
import { partnerCheckLogin } from '../newMain/partnerMain';
import DeptProgRelation from '../../component/deptProgRelation/deptProgRelation';
import SubmitJobConfirm from '../../component/submitJobConfirm/submitJobConfirm';
import CompanyInfoModal from './companyInfoModal';

const { Option } = Select;
const { TextArea } = Input;
const ClassicEditor = window.ClassicEditor;

const PartnerCreateJobPosting = (props) => {
    const history = useHistory();
    const messageRef = useRef();
    const submitJobConfirmRef = useRef();
    const deptProgRelationRef = useRef();
    // const selectStudenModalRef = useRef();
    const [form] = Form.useForm();
    const jobTypeId = Form.useWatch('jobType', form);
    const applyMethodId = Form.useWatch('applyMethod', form);
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [jobPostModel, setJobPostModel] = useState({});
    const [workLocList, setWorkLocList] = useState([]);
    const [applyMethodList, setApplyMethodList] = useState([]);
    const [positionTypeList, setPositionTypeList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [typeList, setTypeList] = useState([]);

    const [progList, setProgList] = useState([]);
    const [cohortProgList, setCohortProgList] = useState([]);
    const [jobPostStatus, setJobPostStatus] = useState("");
    const [studentList, setStudentList] = useState([]);
    const [studentValue, setStudentValue] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isFromStandard, setIsFromStandard] = useState(false);
    const [istoStandard, setIstoStandard] = useState(false);
    const [isFromDate, setIsFromDate] = useState(false);
    const [isToDate, setIsToDate] = useState(false);
    const [jobID, setJobID] = useState();
    const [jobTypeList, setJobTypeList] = useState([]);
    const [isStudentModal, setIsStudentModal] = useState(false);
    const [jobTypeCode, setJobTypeCode] = useState("");
    const [applyMethodCode, setApplyMethodCode] = useState("");
    const [ckeditor, setCkeditor] = useState(null);
    const [ckeditor2, setCkeditor2] = useState(null);
    const [areaOptions, setAreaOptions] = useState([]);
    const [isCompanyInfoModal, setIsCompanyInfoModal] = useState(false);

    useEffect(() => {
        if (!Config.partnerInfo?.partnerId) {
            partnerCheckLogin();
        }
        searchJobType();
        searchWorkLoc();
        searchAllCohortProgramme();
        searchPositionType();
        searchUnit();
        searchTypeList();
        searchAllArea();
        let partnerDuplicateJobId = localStorage.getItem("partnerDuplicateJobId");
        if (partnerDuplicateJobId) {
            searchById(partnerDuplicateJobId);
        } else {
            if (Base.isEmpty(ckeditor)) {
                ClassicEditor.create(document.querySelector('#editor'), Config.ckEditorConfigWebsite)
                    .then(editor => {
                        setCkeditor(editor);
                    }).catch(error => { console.log(error) });
            }
            if (Base.isEmpty(ckeditor2)) {
                ClassicEditor.create(document.querySelector('#editor2'), Config.ckEditorConfigWebsite)
                    .then(editor => {
                        setCkeditor2(editor);
                    }).catch(error => { console.log(error) });
            }
        }
    }, []);

    const searchById = (jobId) => {
        Base.callBackApi("jobPost/searchById", {'jobId': jobId}).then(async (data) => {
            if ("SUCCESS" === data?.msg) {
                let model = data.object ?? {};
                let studentList = model.studentList ?? [];
                setStudentList(studentList);
                initForm(model);
                setJobPostModel(model);
                setJobTypeCode(model?.jobTypeCode ?? "");
                if (Base.isEmpty(ckeditor)) {
                    const editor = await ClassicEditor.create(document.querySelector('#editor'), Config.ckEditorConfigWebsite);
                    editor.setData(model?.jobDesc ?? "");
                    setCkeditor(editor);
                } else {
                    ckeditor.setData(model?.jobDesc ?? "");
                }
                if (Base.isEmpty(ckeditor2)) {
                    const editor2 = await ClassicEditor.create(document.querySelector('#editor2'), Config.ckEditorConfigWebsite);
                    editor2.setData(model?.jobRequirement ?? "");
                    setCkeditor2(editor2);
                } else {
                    ckeditor2.setData(model?.jobRequirement ?? "");
                }
            } else {
                message.error(data?.msg)
            }
        })
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            jobId: model.jobId ?? "",
            jobTitle: model.jobTitle ?? "",
            positionType: model.positionType ?? "",
            jobType: model.jobType ?? "",
            vacancies: model.vacancies ?? null,
            progId: model.progId ?? "",
            progCode: model.progCode ?? "",
            progTitle: model.progTitle ?? "",
            salaryRangeFrom: model.salaryRangeFrom ?? null,
            salaryRangeTo: model.salaryRangeTo ?? null,
            unit: model.unit ?? "",
            expCommenceDate: model.expCommenceDate ? moment(new Date(model.expCommenceDate), Config.dateFormat5) : null,
            expEndDate: model.expEndDate ? moment(new Date(model.expEndDate), Config.dateFormat5) : null,
            workLocId: model.workLocId ? (model.cityId ? [model.cityId + '', model.workLocId + ''] : [model.workLocId + '']) : '',
            lastApplyDate: model.lastApplyDate ? moment(new Date(model.lastApplyDate), Config.dateFormat5) : null,
            jobPostStatus: model.jobPostStatus ?? "",
            estimatedNoOfDaysAWeek: model.estimatedNoOfDaysAWeek ?? null,
            estimatedNoOfHoursAWeek: model.estimatedNoOfHoursAWeek ?? null,
            otherDesc: model.otherDesc ?? "",
            fullPartTime: model.fullPartTime ?? "",
        });
    }

    const searchAllArea = () => {
        Base.callBackApi("commonDropDown/searchAllArea").then((data) => {
            if ("SUCCESS" === data.msg) {
                setAreaOptions(data?.object ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchJobType = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "JOB_TYPE" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setJobTypeList(list ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchWorkLoc = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "WORK_LOCATION" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setWorkLocList(list ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchApplyMethod = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "APPLY_METHOD" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setApplyMethodList(list ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchPositionType = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "POSITION_TYPE" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setPositionTypeList(list ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchUnit = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "UNIT" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setUnitList(list ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const deleteStudent = (index) => {
        const removedElement = studentList.splice(index, 1)
        setStudentList([...studentList]);
    }

    const searchTypeList = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "FULL_PART_TIME" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setTypeList(list ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchAllCohortProgramme = () => {
        Base.callBackApi("commonDropDown/searchAllCohortProgramme", {cohortId: Config.cohort?.cohortId}).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data?.object ?? []
                let model = list.filter(item => item.progCode === 'UNCERTAIN')?.[0]
                let newList = list.filter(item => item.progCode != 'UNCERTAIN')
                if (model) {
                    newList.unshift(model)
                }
                setProgList(newList);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const jump = (path) => {
        localStorage.removeItem("partnerDuplicateJobId");
        history.replace(path);
    }

    const handleChange = (value) => {
        setStudentValue(value);
    };

    const opendialog = (param) => {
        messageRef.current.setContent(param)
        messageRef.current.setIsShow(true)
    }

    const done = () => {
        messageRef.current.setIsShow(false);
        jump('/partner/partnerJobPostingDetail/' + jobID + "/edit");
    }

    const submitJob = (flag) => {
        submitJobConfirmRef.current.setIsShow(false);
        if(flag) {
            setJobPostStatus("SUBMITTED");
            form.submit();
        }
    }

    const opendialog2 = (param) => {
        setIsStudentModal(true);
    }

    const done2 = (list) => {
        if (Base.isNotEmpty(list)) {
            let mergedArray = studentList.concat(list);
            let uniqueArray = mergedArray.reduce((acc, obj) => {
                let existingObj = acc.find(item => item.assignToUserId === obj.assignToUserId);
                if (!existingObj) {
                    acc.push(obj);
                }
                return acc;
            }, []);
            setStudentList(uniqueArray);
        }
        setIsStudentModal(false);
    }

    const saveDraft = () => {
        setJobPostStatus("DRAFT");
        form.submit();
    }

    const saveSubmit = () => {
        submitJobConfirmRef.current.setIsShow(true);
    }

    const onFinish = (values) => {
        if (isLoad) {
            return;
        }
        values.menuFuncId = Config.funcInfo.funcId;
        values.jobPostStatus = jobPostStatus;
        values.partnerId = Config.partnerInfo?.partnerId;
        const newList = [];
        for (let item of studentList) {
            newList.push({
                assignToUserId: item.assignToUserId,
                assignUserType: Config.userInfo?.userType,
            });
        }
        values.studentList = newList;
        values.jobDesc = ckeditor.getData();
        values.jobRequirement = ckeditor2.getData();
        if (values.workLocId.length < 2) {
            values.workLocId = values.workLocId[0];
        } else {
            values.workLocId = values.workLocId[1];
        }
        setIsLoad(true);
        setSpinInfo("Data is processing...")
        Base.callBackApi("jobPost/insert", values).then((data) => {
            if ("SUCCESS" === data.msg) {
                setJobID(data.object);
                if (jobPostStatus == "SUBMITTED") {
                    opendialog("You've successfully created a job posting. Please wait for the THEi to approve the job posting before it can be published.");
                } else {
                    opendialog("You've successfully created a job posting as draft.");
                }
            } else {
                message.error(data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const checkSalaryRangeFrom = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Range From is required.");
        } 
        if (Base.isNotEmpty(value)) {
            if (value < 0) {
                return Promise.reject("Salary greater or equal than 0.");
            }
            const salaryRangeTo = form.getFieldValue('salaryRangeTo');
            if (Base.isNotEmpty(salaryRangeTo)) {
                if (value > salaryRangeTo) {
                    if (!istoStandard) {
                        setIstoStandard(true);
                        form.validateFields(["salaryRangeTo"]);
                    }
                    return Promise.reject("Salary cannot be greater than " + salaryRangeTo);
                }
            } else {
                if (value > 99999999999999) {
                    if (!istoStandard) {
                        setIstoStandard(true);
                        form.validateFields(["salaryRangeTo"]);
                    }
                    return Promise.reject("Salary cannot be greater than " + 99999999999999);
                }
            }
            if (istoStandard) {
                form.validateFields(["salaryRangeTo"]);
            }
        }
        setIstoStandard(false);
        return Promise.resolve();
    };

    const checkSalaryRangeTo = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Range To is required.");
        }
        if (Base.isNotEmpty(value)) {
            if (value > 99999999999999) {
                return Promise.reject("Salary cannot be greater than " + 99999999999999);
            }
            const salaryRangeFrom = form.getFieldValue('salaryRangeFrom');
            if (Base.isNotEmpty(salaryRangeFrom)) {
                if (value < salaryRangeFrom) {
                    if (!isFromStandard) {
                        setIsFromStandard(true);
                        form.validateFields(["salaryRangeFrom"]);
                    }
                    return Promise.reject("Salary should be greater than " + salaryRangeFrom);
                }
            } else {
                if (value < 0) {
                    if (!isFromStandard) {
                        setIsFromStandard(true);
                        form.validateFields(["salaryRangeFrom"]);
                    }
                    return Promise.reject("Salary greater or equal than 0.");
                }

            }
        }
        if (isFromStandard) {
            form.validateFields(["salaryRangeFrom"]);
        }
        setIsFromStandard(false);
        return Promise.resolve();
    };


    const checkStartDate = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Expected Commence Date is required.");
        }
        if (Base.isNotEmpty(value)) {
            const endDate = form.getFieldValue('expEndDate')
            if (Base.isNotEmpty(endDate)) {
                if (Base.afterDate(value, endDate)) {
                    if (!isToDate) {
                        setIsToDate(true);
                        form.validateFields(["expEndDate"]);
                    }
                    return Promise.reject("Expected Commence Date cannot be later than Expected End Date. ")
                }
            }
        }
        if (isToDate) {
            form.validateFields(["expEndDate"]);
        }
        setIsToDate(false);
        return Promise.resolve();
    }

    const checkEndDate = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Expected End Date is required.");
        }
        if (Base.isNotEmpty(value)) {
            const startDate = form.getFieldValue('expCommenceDate')
            if (Base.isNotEmpty(startDate)) {
                if (Base.afterDate(startDate, value)) {
                    if (!isFromDate) {
                        setIsFromDate(true);
                        form.validateFields(["expCommenceDate"]);
                    }
                    return Promise.reject("Expected End Date cannot be earlier than Expected Commence Date.")
                }
            }
        }
        if (isFromDate) {
            form.validateFields(["expCommenceDate"]);
        }
        setIsFromDate(false);
        return Promise.resolve();
    }

    const checkVacancy = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Number of Vacancy is required.");
        }
        if (value <= 0) {
            return Promise.reject("Number of Vacancy must be greater than 0.");
        }
        return Promise.resolve();
    }

    const checkNoDay = (value) => {
        if (value < 0 || value > 7) {
            return Promise.reject("Only numbers from 0-7 can be filled in");
        }
        return Promise.resolve();
    }

    useEffect(() => {
        setJobTypeCode("");
        if (jobTypeId) {
            let model = jobTypeList.find((item) => item.paramId === jobTypeId);
            setJobTypeCode(model?.code ?? "");
        }
    }, [jobTypeId]);

    const onChangeAddressA = (value) => {
        // if(value) {
        //     if(value.length < 2 || !value[1]) {
        //         form.setFieldsValue({
        //             workLocId: [],
        //         });
        //     }
        // }
    }

    const closeCompanyInfoModal = () => {
        setIsCompanyInfoModal(false)
    }

    const checkLastAppluDate = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Application Deadline is required.");
        }
        if (value.startOf('day').isBefore(moment().startOf('day'))) {
            return Promise.reject("Application Deadline must be later than the current date");
        }
        return Promise.resolve();
    }

    return (
        <div id="container" className='websiteTemplate partnerCreateJobPosting'>
            <NewMessage ref={messageRef} done={done} />
            <SubmitJobConfirm ref={submitJobConfirmRef} done={submitJob} />
            <DeptProgRelation ref={deptProgRelationRef} />
            {isStudentModal && <SelectStudenModal onClose={done2} checkboxState={studentList ?? []} progId={form.getFieldValue('progId') || ""} />}
            {isCompanyInfoModal && <CompanyInfoModal onClose={closeCompanyInfoModal} />}
            <Spin size="large" spinning={isLoad} >
                <Form form={form} onFinish={onFinish}>
                    <div className='websiteSysButtonRow'>
                        <div className="detailTitle">Create Job Posting</div>
                        <div className="websiteSysButtonBox">
                            <div className='websiteSysButton' onClick={() => saveDraft()}><img src={saveImg} />Save as Draft</div>
                            <div className='websiteSysButton submitButton' onClick={() => saveSubmit()}><img src={submitImg} />Submit Job Posting</div>
                        </div>
                    </div>
                    <div className="websiteSysContentBox">
                        <div className="websiteSysRow">
                            <div className="websiteSysCol flexBox">
                                <div className='companyLogoBox'>
                                    {Config.partnerInfo?.companyLogo ? <img src={Config.partnerImg + Config.partnerInfo?.companyLogo + '?' + Config.sasToken} /> : <img src={CompanyLogo} />}
                                    <div className='companyNameBox'>{Config.partnerInfo?.companyName}</div>
                                </div>
                                <Button className="websiteSysButton companyInfoButton" style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} icon={<EyeOutlined style={{ fontSize: "18px" }} />} onClick={() => setIsCompanyInfoModal(true)}>Company Info to be Provided</Button>
                            </div>
                            <div className="websiteSysCol flexBox">
                                <div className="websiteSysParam">Job ID</div>
                                <div className="websiteSysInput"></div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Job Title</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="jobTitle"
                                        rules={[
                                            { required: true, message: "Job Title is required." },
                                        ]}
                                    >
                                        <Input className="input" type="text" placeholder="Job Title" maxLength={80} disabled={isDisabled} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam flexTitle mustFill">Designated THEi Programme<QuestionCircleOutlined style={{ color: '#000' }} onClick={() => deptProgRelationRef.current.setIsShow(true)} /></div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="progId"
                                        rules={[
                                            { required: true, message: "Designated THEi Programme is required." },
                                        ]}
                                    >
                                        <Select className='sysSelect' disabled={isDisabled}
                                            onChange={(value) => { setStudentList([]) }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        >
                                            <Option value=''></Option>
                                            {progList.map((item) => <Option key={item.progId} value={item.progId}>{item.progTitle}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Job Mode</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="positionType"
                                        rules={[
                                            { required: true, message: "Job Mode is required." },
                                        ]}
                                    >
                                        <Select className='sysSelect' disabled={isDisabled}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}>
                                            <Option value=''></Option>
                                            {positionTypeList.map((item) => <Option key={item.paramId} value={item.paramId}>{item.parmValue1}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Employment Type</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="jobType"
                                        rules={[
                                            { required: true, message: "Employment Type is required." },
                                        ]}
                                    >
                                        <Select className='sysSelect' disabled={isDisabled}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                            onChange={() => form.setFieldsValue({ otherDesc: "" })}>
                                            <Option value=''></Option>
                                            {jobTypeList.map((item) => <Option key={item.paramId} value={item.paramId}>{item.parmValue1}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        {jobTypeCode == "OTHER" ?
                            <div className="websiteSysRow">
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam">Other Description</div>
                                    <div className="websiteSysInputMax">
                                        <Form.Item
                                            name="otherDesc"
                                        >
                                            <TextArea maxLength={1000} rows={3} placeholder="Other pls specify" disabled={isDisabled} />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            : null}
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Salary (HKD)</div>
                                <div className="websiteSysInput salaryInput">
                                    <Form.Item
                                        name="salaryRangeFrom"
                                        rules={[
                                            { required: false, validator: (rule, value) => checkSalaryRangeFrom(value) },
                                        ]}
                                    >
                                        <InputNumber className="sysSelect" placeholder="Range From"
                                            precision={0} maxLength={14} disabled={isDisabled} />
                                    </Form.Item>
                                    <div style={{ width: "10px" }}>~</div>
                                    <Form.Item
                                        name="salaryRangeTo"
                                        rules={[
                                            { required: false, validator: (rule, value) => checkSalaryRangeTo(value) },
                                        ]}
                                    >
                                        <InputNumber className="sysSelect" placeholder="Range To"
                                            precision={0} maxLength={14} disabled={isDisabled} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Salary Basis</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="unit"
                                        rules={[
                                            { required: true, message: "Salary Basis is required." },
                                        ]}
                                    >
                                        <Select className='sysSelect' disabled={isDisabled}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}>
                                            <Option value=''></Option>
                                            {unitList.map((item) => <Option key={item.paramId} value={item.paramId}>{item.parmValue1}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Estimated No. of Days a Week (Optional)</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="estimatedNoOfDaysAWeek"
                                        rules={[
                                            { required: false, validator: (rule, value) => checkNoDay(value) },
                                        ]}
                                    >
                                        <InputNumber className="sysInputNumber" placeholder="Estimated No. of Days a Week"
                                            precision={0} maxLength={1} disabled={isDisabled} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Estimated No. of Hours a Week (Optional)</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="estimatedNoOfHoursAWeek"
                                        rules={[
                                            { required: false, },
                                        ]}
                                    >
                                        <InputNumber className="sysInputNumber" placeholder="Estimated No. of Hours a Week"
                                            precision={0} maxLength={3} disabled={isDisabled} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Expected Date</div>
                                <div className="websiteSysInput salaryInput">
                                    <Form.Item
                                        name="expCommenceDate"
                                        rules={[
                                            { required: true, validator: (rule, value) => checkStartDate(value) },
                                        ]}
                                    >
                                        <DatePicker placeholder="Commence Date"
                                            className="parts-numberInput datePickerAllWidth"
                                            format={Config.dateFormatEn} disabled={isDisabled}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode} />
                                    </Form.Item>
                                    <div style={{ width: "10px" }}>-</div>
                                    <Form.Item
                                        name="expEndDate"
                                        rules={[
                                            { required: true, validator: (rule, value) => checkEndDate(value) },
                                        ]}
                                    >
                                        <DatePicker placeholder="End Date"
                                            className="parts-numberInput datePickerAllWidth"
                                            format={Config.dateFormatEn} disabled={isDisabled}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Application Deadline</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="lastApplyDate"
                                        rules={[
                                            { required: false, validator: (rule, value) => checkLastAppluDate(value) },
                                        ]}
                                    >
                                        <DatePicker placeholder="Application Deadline"
                                            className="parts-numberInput input"
                                            disabledDate={(current) => Base.afterDate(new Date(), current)}
                                            format={Config.dateFormatEn} disabled={isDisabled}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Number of Vacancy</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="vacancies"
                                        rules={[
                                            { required: true, validator: (rule, value) => checkVacancy(value) },
                                        ]}
                                    >
                                        <InputNumber className="sysInputNumber" placeholder="Number of Vacancy"
                                            precision={0} maxLength={3} disabled={isDisabled} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Work Location</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="workLocId"
                                        rules={[
                                            { required: true, message: "Work Location is required." },
                                        ]}
                                    >
                                        <Cascader disabled={isDisabled}
                                            options={areaOptions}
                                            onChange={onChangeAddressA}
                                            placeholder=""
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Job Description</div>
                                <div className="websiteSysInputMax">
                                    <div id="editor" className="editor"></div>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Job Requirement</div>
                                <div className="websiteSysInputMax">
                                    <div id="editor2" className="editor"></div>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam" style={{ display: 'flex' }}>
                                    <div>Assigned Students (Optional) </div>
                                    <Popover placement="bottom" content={<div style={{ textAlign: 'justify', hyphens: 'none', maxWidth: '370px', wordBreak: 'break-word' }}>
                                        To restrict this job posting to specific student(s) only, please enter their corresponding Student ID(s).
                                        <br></br>
                                        <br></br>
                                        If the field is left blank, the job posting will be available to all students enrolled in the specified Programme.
                                    </div>} trigger="hover" >
                                        <div className='questionTitle'><QuestionCircleOutlined style={{ color: '#000' }} /></div>
                                    </Popover>
                                </div>

                                <div className="websiteSysInputMax">
                                    {studentList != null && studentList.length > 0 ?
                                        <div className="studentAssignedList" style={{ width: '100%' }} >
                                            {studentList.map((item, index) => (
                                                <div className="studentAssigned" key={index}>
                                                    <img className="studentAssignedimg" src={item.studentPhoto ? Config.studentPhotoPath + item.studentPhoto + '?' + Config.sasToken : studentDefaultPictureImg}></img>
                                                    <div className="studentNameText">{item.firstName + " " + item.lastName}</div>
                                                    <div className="studentDeleteImg" onClick={() => deleteStudent(index)}>
                                                        <CloseCircleOutlined />
                                                    </div>
                                                </div>
                                            ))}
                                            <Button className="addStudentInput" onClick={() => opendialog2()}>+ Add Student</Button>
                                        </div>
                                        : <Button className="addStudentInput" onClick={() => opendialog2()}>+ Add Student</Button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="websiteSysButtonBox">
                        <div className='websiteSysButton' onClick={() => saveDraft()}><img src={saveImg} />Save as Draft</div>
                        <div className='websiteSysButton submitButton' onClick={() => saveSubmit()}><img src={submitImg} />Submit Job Posting</div>
                    </div>
                </Form>
            </Spin>
        </div>
    )
}

export default PartnerCreateJobPosting;